import { combineReducers } from 'redux';

import totalNumbers from './totalNumbers';
import currentPage from './currentPage';
import currentTable from './currentTable';

const paginationBarReducer = combineReducers({ totalNumbers, currentPage, currentTable });

export default paginationBarReducer;
